// Global layout-related constants shared across the web app
export const NAVBAR_HEIGHT = 56;

// The fixed header spans the status bar on iOS, so its box grows by the top inset while the row
// inside it stays NAVBAR_HEIGHT tall. This also offsets AppShell.Main. See app/safe-area.css.
// The first term reproduces what Mantine's `rem()` would have made of NAVBAR_HEIGHT — passing a
// calc() opts out of that conversion, and a raw px value would stop honouring --mantine-scale.
export const HEADER_HEIGHT = `calc(${NAVBAR_HEIGHT / 16}rem * var(--mantine-scale) + var(--safe-area-top))`;

export const CONTENT_MAX_WIDTH = 1400;
